




















import { Component, Vue } from "vue-property-decorator";
import api from "@/api/index.ts";
import { mapGetters } from "vuex";
import ListShops from "@/components/pages/shops/ListShops.vue";
import PlaceholderBlock from "@/components/pages/shops/PlaceholderBlock.vue";
import ReadmoreBtn from "@/components/pages/shops/ReadmoreBtn.vue";
import Loader from "@/components/pages/shops/Loader.vue";

@Component({
  name: "CategoriesContainer",
  components: {
    ListShops,
    PlaceholderBlock,
    Loader,
    ReadmoreBtn
  },
  computed: mapGetters("shops", ["getShops"])
})
export default class CategoriesContainer extends Vue {
  isLoading: boolean = false;

  showMore(letter, counter) {
    this.$refs["loader_" + letter][0].$el.style.display = "block";
    let load = this.$refs["loader_" + letter][0].$el;

    this.$store.dispatch("shops/showMoreShops", { letter, counter, load });
  }

  created() {
    this.$store.dispatch("shops/getAllShops");
  }
}
